export default {
  GET_ALL_MATERIALS: "GET_ALL_MATERIALS",
  SET_MATERIAL_SEARCH_DATA: "SET_MATERIAL_SEARCH_DATA",
  GET_ALL_CONTAINER: "GET_ALL_CONTAINER",
  SAVE_CONTAINER: "SAVE_CONTAINER",
  SET_MATERIAL_TABLE_OPTIONS: "SET_MATERIAL_TABLE_OPTIONS",
  SET_MATERIAL_APPROVE_TABLE_OPTIONS:"SET_MATERIAL__APPROVE_TABLE_OPTIONS"
};
